import React from 'react';
import CounterUp from '../../component/counterup/CounterUp';
// import SectionTitle from '../../elements/section-title/SectionTitle';


const CounterUpOne = () => {
    return (
        <div className="section bg-color-dark">
            {/* <div className="container">
            <SectionTitle 
                    subtitle="Featured Case Study"
                    title="Design startup movement"
                    description="Origin is the most popular, awesome, incredible Software Company"
                    textAlignment="heading-light"
                    textColor=""
                />
            </div> */}
            <div className="row">
                    <CounterUp colSize="col-lg-3 col-6" layoutStyle="" evenTopMargin="" />
                </div>
        </div>
    )
}


export default CounterUpOne;